import { Link, useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";



const CatalogItemDesc = ({children}) => {

    return (
        <div className="catalog_item_desc">
            {children}
        </div>
    )
}
  
export default CatalogItemDesc